import React, { FC, useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { useParams } from 'react-router'
import { dataAll } from './TradeHistoryTableLists'
import { TableComponent } from '../../../../../../components/Dashboard/Table'
import { useRest } from '../../../../../../components/Context'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    margin: theme.spacing(2, 0, 4, 0),
  },
}))

export const ViewAllTradesHistory: FC = () => {
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})
  const { id } = useParams() as { [key: string]: string }

  const loadData = useCallback(
    async (page) => {
      let cleanupFunction = false
      setLoading(true)

      rxiosAuth
        .get(id ? `${dataAll.request}/${id}?page=${page}&count=10` : `${dataAll.request}?page=${page}&count=10`)
        .subscribe(
          // eslint-disable-next-line
          (next: any) => {
            setValues(next)
            if (!cleanupFunction) setLoading(false)
          },
          (error) => {
            toast.error(error)
            setLoading(false)
          },
          () => {
            setLoading(false)
          },
        )
      cleanupFunction = true
      // eslint-disable-next-line
    },
    [rxiosAuth, id],
  )

  useEffect(() => {
    ;(async () => {
      await loadData('1')
    })()
    // eslint-disable-next-line
  }, [])
  return (
    <Grid item xs={12} className={classes.formWrap}>
      <Grid item xs={12} className={classes.container}>
        <Typography variant={'h1'}>Trades</Typography>
      </Grid>

      <Grid item xs={12} className={classes.sectionWrap}>
        <TableComponent
          columns={dataAll.columns}
          data={values.items}
          params={values.meta}
          // eslint-disable-next-line
          loadData={(pageNumber: string | number) => loadData(pageNumber)}
          loading={loading}
        />
      </Grid>
    </Grid>
  )
}
